import React from "react";
import { Box, Paper, styled, Typography } from "@mui/material";

const MainBox = styled(Box)(({theme}) => ({
  width: "15vw",
  height: "25vh",
  display: "flex",
  flexDirection: "column",
  borderRadius: "5px",
  margin: theme.spacing(1, 0),
  [theme.breakpoints.down('mdlg')]: {
    width: "25vw",
    height: "30vh",
  },
  [theme.breakpoints.down('sm')]: {
    width: "80vw",
  }
}))

const IndustryName = styled(Typography)(({theme}) => ({
  fontSize: '0.8rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  
  //responsive
  [theme.breakpoints.down('bp1200')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '0.6rem',
  },
  [theme.breakpoints.down('mdlg')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
  }
}))

function IndustryCard({ CardImg, Title, Info }) {
  return (
    <MainBox>
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          transition: "background-color 0.5s ease",
          "&:hover": {
            bgcolor: "rgb(243, 243, 243)",
          },
        }}
      >
        <Box
          component="img"
          src={CardImg}
          loading="lazy"
          sx={{
            width: "100%",
            height: "80%",
            objectFit: "cover",
            borderRadius: "5px 5px 0 0",
          }}
        />
        <Box
          sx={{
            bgcolor: "transparent",
            width: "100%",
            height: "20%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontFamily: "sans-serif",
          }}
        >
          <IndustryName gutterBottom fontWeight={600} >
            {Title}
          </IndustryName>
          {/* <Typography
            sx={{
              mx: 2,
              fontSize: "0.8rem",
              color: "text.secondary",
              height: '70%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {Info}
          </Typography> */}
        </Box>
      </Paper>
    </MainBox>
  );
}

export default IndustryCard;
